import React from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import Language from './app-language';
import AppUtils from '../utils/app-utils';

class Index extends React.Component {

	render() {

		return(
			<div className="container-fluid">
			<div className="row pt-xl-5">&nbsp;</div>

			<div className="row pt-xl-5 ml-2 mr-2 ml-xl-5 mr-xl-5">
				<div className="col-xl-6 col-lg-12 pl-xl-5 text-center text-xl-left" >
					<Language />
					<div className="pt-3 pt-xl-5">
						<h1 className="ph-fc pb-3 ph-fs">{AppUtils.replaceNickname(this.props.language.title)}</h1>
					</div>

					<div className="d-block d-xl-none my-auto">
						<img className="img-fluid" src="https://cdn.moes.beer/images/placeholder/phones_small.png" alt="Game Preview" />
					</div>

                    <div>
                        <h1 style={{ fontSize: "2.5em", marginBottom: "10px" }}>🍻 Moes v2 Beta is Here</h1>

                        <p style={{marginBottom: 0}}>
                            We've been busy. Not super busy, more like "I always look annoyed. When you look annoyed all the time, people think you're busy".
                        </p>

                        <p style={{marginBottom: 0}}>
                            The <strong>Moes Beta</strong> is packed with <strong>more questions</strong>, a <strong>fresh new UI</strong>, and an overall{" "}
                            <strong>smoother, funnier, slightly more chaotic drinking experience</strong> (if it doesn't crash).
                        </p>

                        <p style={{marginBottom: 0}}>
                            Expect better flow, sharper design, and questions that will make you laugh,
                            cringe, and seriously reconsider your friendships.
                        </p>

                        <p style={{ fontSize: "1.3em", marginTop: "30px" }}>
                            So... do you want to test the new beta version?
                        </p>

                        <div style={{ marginTop: "25px" }}>
                            <a href="https://beta.moes.beer">
                                <button
                                    onClick={() => {}}
                                    style={{
                                    padding: "15px 25px",
                                    margin: "10px",
                                    fontSize: "1em",
                                    border: "none",
                                    borderRadius: "8px",
                                    backgroundColor: "#28a745",
                                    color: "white",
                                    cursor: "pointer",
                                    }}
                                    className="btn-placeholder ph-fc"
                                    >
                                    Yes, I like new things and alcohol!
                                </button>
                            </a>

                            <Link to="/play">
                                <button
                                    onClick={() => {}}
                                    style={{padding: "15px 25px", margin: "10px", fontSize: "1em", border: "none", borderRadius: "8px", backgroundColor: "#6c757d", color: "white", cursor: "pointer"}}
                                    >
                                    No thanks, I’ll stick to the old version (and my non-alcoholic lifestyle)
                                </button>
                            </Link>
                        </div>
                        
                        <div className="lead ph-fc text-left text-md-center text-xl-left">
                            {this.props.language.socialMedia}
                            <div className="p-1">
                                <Link to={{ pathname: "https://instagram.com/moesbeergame"}} target="_blank" rel="noopener noreferrer"  style={{color: '#734e9a'}}><i className="fab fa-instagram fa-2x"></i></Link>
                            </div>
                        </div>
                    </div>
                </div>
				<div className="col-xl-6 col-lg-12 col-md-12 text-center">
					<div className="d-none d-xl-block my-auto">
						<img className="img-fluid" src="https://cdn.moes.beer/images/placeholder/phones.png" alt="Game Preview" />
					</div>
				</div>
			</div>
		</div>
		);
	}
}
function mapStateToProps(state) {
	return {
		language: state.ui.language.index,
	}
}
export default connect(mapStateToProps)(Index);
